import { useEffect, useRef } from "react";
import ContactEnquiry from "screens/sharedScreen/ContactEnquiry";
import './ContactUs.scss';
import { Helmet } from "react-helmet-async";

const ContactUs = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 1; // 0.5x speed (half speed)
        }
    }, []);


    return (
        <>
            <Helmet>
                <title>Contact Us - Get in Touch with Global Freight Forwarding Experts</title>
                <meta name="description" content="Reach out to 1WN’s global logistics network for expert freight forwarding support, reliable logistics partnerships, and efficient supply chain solutions." />
                <meta name="keywords" content="Contact Global Logistics Network, Freight Forwarding Support, Logistics Partners Contact, International Shipping Inquiries, Freight Forwarding Services Contact, Supply Chain Solutions Help, Trusted Freight Forwarders, Logistics Customer Service, Freight Network Assistance" />
            </Helmet>
            <div>




                <section class="page-header mebership-center member-section">
                    <video ref={videoRef} autoPlay muted loop playsInline>
                        <source src="https://www.oneworldnetwork.co/video/1wn-contact-us.mp4" type="video/mp4" />
                    </video>

                </section>



                <section className="contact" id="contact">
                    <div className="container">
                        <div className="heading text-center">
                            <p>At <span className="one--">1</span><span className="wn">WN</span> - <span className="one--">One</span> <span className="wn">World</span> <span className="one--">One</span> <span className="wn">Network</span>, we believe that strong connections are the foundation of successful business growth. Whether you’re looking to expand your network, explore new markets, or learn more about the exclusive benefits of <span className="one--">1</span><span className="wn">WN</span> membership, we’re here to help. Our dedicated team is available to answer your questions, provide personalized support, and guide you through your journey with <span className="one--">1</span><span className="wn">WN</span>. </p><br />
                            <p className="mt-2">Feel free to reach out to us through any of our regional offices <br />or schedule a visit to one of our key locations:</p>
                        </div>

                        <div className="row address-lists">
                            <div className="col-lg-3 mb-2">
                                <div className="d-flex justify-content-center cont-location">
                                    <div className='icon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div className="location--">
                                        <p>Dubai, UAE
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-2">
                                <div className="d-flex justify-content-center cont-location">
                                    <div className='icon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div className="location--">
                                        <p>Delhi, India
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-2">
                                <div className="d-flex justify-content-center cont-location">
                                    <div className='icon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div className="location--">
                                        <p>Casablanca, Morocco
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-2">
                                <div className="d-flex justify-content-center cont-location">
                                    <div className='icon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div className="location--">
                                        <p>Bangkok, Thailand
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="contact " id="contact">
                    <div className="container">
                        <div className="row contact-detail-sec">
                            <div className="col-lg-5 col-md-12 position-relative">
                                <div className='contact-page'>
                                    <div className="title">
                                        <h3>Contact Us</h3>
                                    </div>
                                    <div className="contact-- content">
                                        <div className="info d-block">
                                            {/* <div>
                                            <h4>Addresses
                                            </h4>
                                        </div> */}
                                            <div className="d-flex">
                                                <div className='icon'>
                                                    <i className="fas fa-map-marker-alt"></i>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <p className="icon-one">
                                                        <a href='https://www.google.com/maps/place/DAFZ+-+Dubai+Airport+Free+Zone/@25.2604508,55.3702747,17z/data=!3m1!4b1!4m6!3m5!1s0x3e5f5db3d5235501:0xb8a647c098c4a23e!8m2!3d25.260446!4d55.372855!16s%2Fg%2F11b7hm0xgm?entry=tts&g_ep=EgoyMDI0MDkxNi4wKgBIAVAD' target='_blank'>#511, 8W Building,
                                                            DAFZ Dubai<br /> Airport, UAE </a>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex mt-2">
                                                <div className='icon'>
                                                    <i className="fas fa-map-marker-alt"></i>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <p className="icon-one">
                                                        <a href='https://www.google.com/maps/place/Radisson+Blu+Plaza+Hotel,+Delhi+Airport/@28.543838,77.1175718,17z/data=!4m9!3m8!1s0x390cfeb030000001:0x30ba15bbf06dfb74!5m2!4m1!1i2!8m2!3d28.5438333!4d77.1201521!16s%2Fg%2F11xy8yzzv?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D' target='_blank'>Radisson Blu Plaza Hotel,
                                                            <br /> Delhi Airport, INDIA</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="info d-block">

                                            <div className="d-flex">
                                                <div className='icon'>
                                                    <i className="fas fa-envelope"></i>

                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <p className="icon-one">
                                                        <a href="mailto:info@oneworldnetwork.co" rel="noopener noreferrer" target="_blank">info@oneworldnetwork.co</a>
                                                    </p>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="info d-block">
                                            {/* <div>
                                            <h4>Phone No
                                            </h4>
                                        </div> */}
                                            <div className="d-flex">
                                                <div className='icon'>
                                                    <i className="fas fa-mobile-alt"></i>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <p className="icon-one">
                                                        <a href="tel:+91- 73 037 33554" target="_blank" rel="noopener noreferrer">+91-7303733554</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="info d-block">

                                            <div className="d-flex">
                                                <div class="social-menu social-- d-flex justify-content-center">
                                                    <ul className="ul-list">
                                                        <li>
                                                            <a href="https://www.instagram.com/one_world_network_" target="blank">
                                                                <i class="fab fa-instagram"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="https://www.linkedin.com/company/1wn-one-world-one-network/" target="blank"><i class="fab fa-linkedin-in"></i></a></li><li><a href="https://www.facebook.com/1wn.co"><i class="fab fa-facebook" target="blank"></i></a></li><li><a href="https://www.youtube.com/@1wn_co" target="blank"><i class="fab fa-youtube"></i></a></li></ul></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-12 col-sm-12">
                                {/* <form className="form-margin"> */}
                                <ContactEnquiry />
                                {/* </form> */}
                            </div>
                        </div>
                    </div>
                </section >

                {/* <Testimonial /> */}



            </div >
        </>
    )
}

export default ContactUs